import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useSelector } from 'react-redux'

import Select_DSAS from '../../../../../../dsasComponents/Select_Dsas.js'

import {TextField, Button, Typography, Paper, Select, MenuItem, NativeSelect, InputLabel, OutlinedInput, FormControl, Grid, Box, Avatar, Stack} from '@mui/material'
import { useTheme } from '@mui/styles'
import useStyles from './styles.js'
import DateTimePicker_Dsas from '../../../../../../dsasComponents/DateTimePicker_Dsas.js'

import { discipline_all, getActualSeason, getDays, season_all, seasons_all } from '../../../../../../bdd/bddSTUB.js'
import SoccerFeuilleMatch from '../../../../../../dsasComponents/feuillematch/SoccerFeuilleMatch.js'
import RugbyFeuilleMatch from '../../../../../../dsasComponents/feuillematch/RugbyFeuilleMatch.js'
import { isAdminDSAS } from '../../../../../../actions/auth.js'
import SelectGroupProvider from '../../../../../../dsasComponents/SelectGroupProvider.js'
import { isStepComplete } from '../../../../../Live/utils/feuilleMatch.js'
import { useFetch } from '../../../../../../filters/useFetch.js'
import { fetchCompetitions, fetchTeams } from '../../../../../../api/index.js'
import { FETCH_ALL_COMPETITION, FETCH_ALL_TEAM } from '../../../../../../constants/actionTypes.js'
import Select_Dsas from '../../../../../../dsasComponents/Select_Dsas.js'


const MatchSteps = ({step, stepInfos, setStepInfos}) => {
    const classes = useStyles();

    const [matchData, setMatchData] = useState(stepInfos.data)

    let stepsComponents = [
        Step1
    ]

    const completeStep = (data) => {
        setStepInfos(state => {
            return {
                ...state, data : {...state.data, ...data}, isComplete : state.isComplete.map((b, idx) => idx === step ? true : b)
            }
        })
    }

    const uncompleteStep = (data) => {
        setStepInfos(state => {
            return {
                ...state, data : {...state.data, ...data}, isComplete : state.isComplete.map((b, idx) => idx === step ? false : b)
            }
        })
    }

    return (
        
        <Paper className={classes.paper}>
        {React.createElement(stepsComponents[step], {
            data: {...stepInfos.data},
            completeStep,
            uncompleteStep,
            matchData,
            setMatchData
        })}
        </Paper>
    )
}

const Step1 = ({data, completeStep, uncompleteStep, matchData, setMatchData}) => {
    const classes = useStyles();
    const theme = useTheme();

    // Datas
    // FILTERS
    const [filters, setFilters] = useState({discipline : '', provider : '', season : getActualSeason()})

    const [competitions, loadingCompetition] = useFetch(fetchCompetitions, filters, undefined, FETCH_ALL_COMPETITION)

    const days_all = [
        { _id : 'quarter-final', name : 'quarter-final'}, 
        { _id : 'semi-final', name : 'semi-final'}, 
        { _id : 'final', name : 'final'}, 
    ]
    for(var i = 26 ; i >= 1 ; i--){
        days_all.unshift({ _id : i, name : i})
    }

    const teams_all_filter = useMemo(() => {
        return {competition : matchData.competition}
    }, [matchData.competition])

    const [teams_all, loadingTeamsAll] = useFetch(fetchTeams, teams_all_filter, ['competition'], FETCH_ALL_TEAM)

    useEffect(() => {
        setMatchData(m => ({...m, competition : ''}))

    }, [filters.discipline])

    useEffect(() => {
        setMatchData(m => ({...m, day : '', homeTeam : '', awayTeam : ''}))

    }, [matchData.competition, setMatchData])

    // END DATAS

    const getDaysAll = useCallback(() => {

        if(!matchData.competition)
            return []

        let competitionSelected = competitions.find(c => c._id === matchData.competition)

        let daysDATA = getDays(competitionSelected.nbDays, competitionSelected.nbTeamFinalPhase);

        return daysDATA

    }, [matchData.competition])

    const handleChange = (e) => {
        let targetName = e.target.name
        let competition = matchData.competition
        if(targetName==='provider'){
            competition = ''
            setFilters(state => ({...state, provider : e.target.value}))
        }
            

        if(targetName==='competition'){
            competition = e.target.value
        }
        
        setMatchData(s => ({...s, [targetName]: e.target.value, competition}))

        if(targetName === "competition"){
            // On cherche la discipline de la compet
            let actualDiscipline = competitions.find(c => c._id === e.target.value).discipline

            if(actualDiscipline === 'soccer'){
                setMatchData(s => ({
                    ...s, 
                    homeHolders : [],
                    awayHolders : [],
                    homeSubstitutes : [{}, {},{}, {}, {}],
                    awaySubstitutes : [{}, {},{}, {}, {}],
                    homeComposition : '442',
                    awayComposition : '442',
                }))
            }else if(actualDiscipline === 'rugby'){
                setMatchData(s => ({
                    ...s, 
                    homeHolders : [],
                    awayHolders : [],
                    homeSubstitutes : [{}, {},{}, {}, {}],
                    awaySubstitutes : [{}, {},{}, {}, {}],
                    homeComposition : 'rugby15',
                    awayComposition : 'rugby15',
                }))
            }
        }
    }

    const handleChangeDateTime = (value) => {
        let targetName = "dateTime"
        setMatchData(s => ({...s, [targetName]: value}))
    }

    useEffect(() => {
        isCompletedStep()
      }, [matchData])

    useEffect(() => {
        if(!matchData.competition)
            return
        // On cherche la discipline de la compet
        let actualDiscipline = competitions.find(c => c._id === matchData.competition).discipline

        if(actualDiscipline === 'soccer'){
            setMatchData(s => ({
                ...s, 
                homeHolders : [],
                awayHolders : [],
                homeSubstitutes : [{}, {},{}, {}, {}],
                awaySubstitutes : [{}, {},{}, {}, {}],
                homeComposition : '442',
                awayComposition : '442',
            }))
        }else if(actualDiscipline === 'rugby'){
            setMatchData(s => ({
                ...s, 
                homeHolders : [],
                awayHolders : [],
                homeSubstitutes : [{}, {},{}, {}, {}],
                awaySubstitutes : [{}, {},{}, {}, {}],
                homeComposition : 'rugby15',
                awayComposition : 'rugby15',
            }))
        }
      }, [matchData.competition])

    const isCompletedStep = useCallback(() => {

        const {competition, day, dateTime, homeTeam, awayTeam} = matchData

        let isCompleted = 
        competition && competition !== '' &&
        day && day !== '' &&
        dateTime && dateTime !== '' &&
        homeTeam && homeTeam !== '' &&
        awayTeam && awayTeam !== ''


        if(isCompleted)
            completeStep(matchData)
        else
            uncompleteStep(matchData)
    }, [matchData])

    const clear = () => {
        setMatchData(data)
    }


    return (
        <>
                {isAdminDSAS() && <SelectGroupProvider value={matchData.provider} onChange={handleChange}/>}

                {/*Discipline*/} 
                <FormControl sx={{}} fullWidth >
                    <InputLabel id={"disciplinecompet"}>Discipline</InputLabel>
                    <Select 
                        labelId={'disciplinecompet'}
                        id={"disciplinecompetselect"}
                        name={'discipline'}
                        value={filters.discipline}
                        label={'Discipline'}
                        onChange={(e) => setFilters(state => ({...state, discipline : e.target.value}))}
                    >
                        {discipline_all && discipline_all.map(i => (<MenuItem key={i._id} value={i._id}>{i.name ? i.name : `${i.lastname} ${i.firstname}`}</MenuItem>))}
                    </Select>
                </FormControl>

                <Select_Dsas
                            className={classes.selectInput}
                            labelId = {"season_label"}
                            label = {"Saison"}
                            selectId = {"season"}
                            name = {"season"}
                            value = {filters.season}
                            items = {season_all}
                            onChange = {(e) => setFilters(state => ({...state, season : e.target.value}))}
                />

                {/*Competition*/}
                <Select_DSAS className={classes.selectInput}
                    labelId = {"match_step1_competition_label"}
                    label = {"Compétition"}
                    selectId = {"match_step1_competition"}
                    name = {"competition"}
                    value = {matchData.competition}
                    items = {competitions}
                    onChange = {handleChange}
                />

                {/*Journee*/}
                <Select_DSAS className={classes.selectInput}
                    labelId = {"match_step1_day_label"}
                    label = {"Journée"}
                    selectId = {"match_step1_day"}
                    name = {"day"}
                    value = {matchData.day}
                    items = {getDaysAll()}
                    onChange = {handleChange}
                />

                <DateTimePicker_Dsas className={classes.selectInput}
                    label={"Coup d'envoi"}
                    name={"dateTime"}
                    value={matchData.dateTime}
                    onChange = {handleChangeDateTime}
                />

                {/*Home team*/}
                <Select_DSAS className={classes.selectInput}
                    labelId = {"match_step1_hometeam_label"}
                    label = {"Equipe domicile"}
                    selectId = {"match_step1_hometeam"}
                    name = {"homeTeam"}
                    value = {matchData.homeTeam}
                    items = {teams_all}
                    onChange = {handleChange}
                />

                {/*Away team*/}
                <Select_DSAS className={classes.selectInput}
                    labelId = {"match_step1_awayteam_label"}
                    label = {"Equipe extérieure"}
                    selectId = {"match_step1_awayteam"}
                    name = {"awayTeam"}
                    value = {matchData.awayTeam}
                    items = {teams_all}
                    onChange = {handleChange}
                />

                <Button variant="contained" color="secondary" size="small" onClick={clear}> Clear </Button>
        </>
    )
}

const Step2 = ({data, completeStep, matchData, setMatchData}) => {

    const competitions_all = useSelector((state) => state.competitions)

    const getActualDiscipline = useCallback(() => {
        let actualDiscipline = competitions_all.find(c => c._id === matchData.competition).discipline

        return actualDiscipline
    }, [competitions_all, matchData.competition])



    const myComponent = useCallback(() => {

        if(matchData.competition){
            let compSelected = competitions_all.find(c => c._id === matchData.competition)

            if(compSelected.discipline === 'rugby'){
                return RugbyFeuilleMatch
            }
                
            else if(compSelected.discipline === 'soccer'){
                return SoccerFeuilleMatch
            }
                
        }

    }, [matchData.competition, competitions_all])

    useEffect(() => {
        isCompletedStep()
      }, [matchData])

      const isCompletedStep = () => {

        let isCompleted = isStepComplete(matchData.homeHolders, getActualDiscipline())

        if(isCompleted)
            completeStep(matchData)
    }

    // 1 colonne par équipe. Chaque équipe possède son nombre de joueurs en select, permettant 
    return (
        React.createElement(myComponent(), {
            data,
            completeStep,
            matchData,
            setMatchData,
            isHome : true,
            isPopup : true
        })
    )
}

const Step3 = ({data, completeStep, matchData, setMatchData}) => {

    const competitions_all = useSelector((state) => state.competitions)

    const myComponent = useCallback(() => {
        if(matchData.competition){
            let compSelected = competitions_all.find(c => c._id === matchData.competition)

            if(compSelected.discipline === 'rugby')
                return RugbyFeuilleMatch
            else if(compSelected.discipline === 'soccer')
                return SoccerFeuilleMatch
        }

    }, [matchData.competition])

    useEffect(() => {
        isCompletedStep()
      }, [matchData])

      const getActualDiscipline = useCallback(() => {
        let actualDiscipline = competitions_all.find(c => c._id === matchData.competition).discipline

        return actualDiscipline
    }, [competitions_all, matchData.competition])

      const isCompletedStep = () => {

        const {awayHolders, awaySubstitutes} = matchData

        let isCompleted = isStepComplete(matchData.homeHolders, getActualDiscipline())
        
        if(isCompleted)
            completeStep(matchData)
    }

    // 1 colonne par équipe. Chaque équipe possède son nombre de joueurs en select, permettant 
    return (
        React.createElement(myComponent(), {
            data,
            completeStep,
            matchData,
            setMatchData,
            isHome : false,
            isPopup : true
        })
    )
}

export default MatchSteps